import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { konaseemaHighlights } from "@/mocks/siteData";

export default function ExploreSection() {
  return (
    <section id="konaseema" className="sun-glaze bg-background-50">
      <div className="relative w-full h-[24rem] md:h-[32rem] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Breathtaking%20scenic%20view%20of%20Konaseema%20backwaters%20in%20Andhra%20Pradesh%20with%20lush%20coconut%20groves%20reflected%20in%20calm%20green%20water%2C%20narrow%20wooden%20boat%2C%20fisherman%2C%20soft%20misty%20fresh%20morning%20light%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=900&seq=rythugaru-konaseema-backwaters&orientation=landscape"
          width={1920}
          height={900}
          alt="Scenic backwaters of Konaseema surrounded by coconut groves"
          title="Konaseema - where the Rythugaru journey begins"
          className="w-full h-full object-cover object-top"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"></div>
        <div className="absolute inset-0 flex items-end">
          <div className="w-full px-4 md:px-8 pb-10 md:pb-14">
            <Reveal>
              <div className="mb-4">
                <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" />
              </div>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-300">
                Where Our Journey Begins
              </span>
              <h2 className="font-heading text-3xl md:text-5xl text-background-50 font-semibold mt-3">
                Konaseema — The Beauty of Rural Andhra Pradesh
              </h2>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-6">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              Our journey begins in <strong className="text-foreground-950">Konaseema</strong>, a
              region known for its lush green landscapes, coconut groves, waterways, villages, and
              rich agricultural traditions. Here, agriculture isn't just an occupation.
            </p>
            <p className="font-heading text-2xl md:text-3xl text-primary-700 italic mt-5">
              It is a way of life.
            </p>
            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              Experience the farms, food, waterways, villages, traditions, and stories that make
              Konaseema special.
            </p>
            <Link
              to="/konaseema"
              className="mt-8 inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Konaseema
              <i className="ri-arrow-right-line"></i>
            </Link>
          </Reveal>

          <Reveal className="lg:col-span-6" delay={120}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {konaseemaHighlights.map((item) => (
                <div
                  key={item.label}
                  className="bg-background-100 border border-background-200 rounded-lg p-6"
                >
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <p className="text-base font-medium text-foreground-900 mt-4">{item.label}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}